import { render, staticRenderFns } from "./ReturnMedicalRecord.vue?vue&type=template&id=694cc9e4&"
import script from "./ReturnMedicalRecord.vue?vue&type=script&lang=js&"
export * from "./ReturnMedicalRecord.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports